import { render, staticRenderFns } from "./AddPointsBuildListOfUsers.vue?vue&type=template&id=78a406d1&scoped=true&"
import script from "./AddPointsBuildListOfUsers.vue?vue&type=script&lang=js&"
export * from "./AddPointsBuildListOfUsers.vue?vue&type=script&lang=js&"
import style0 from "./AddPointsBuildListOfUsers.vue?vue&type=style&index=0&id=78a406d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a406d1",
  null
  
)

export default component.exports